import { Grid, Alert } from "@mui/material"
import { useContext, useEffect } from "react";
import { ContextOperacion, ContextOperacionType } from "../../RefactorLayout";
import { useLoader } from "src/hooks/useLoader";
import { EntityWithIdFields, QueryStatus } from "src/types";
import { SubmitHandler, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import toast from "react-hot-toast";
import { FormOperacionCorporate, OperacionCorporate, schemaFormOperacionCorporate } from "./types/types";
import { HttpCorporate } from "./api/httpCorporate";
import { useOperacionCorporate } from "./hooks/useOperacionCorporate";
import { SeccionFirmas } from "../../components/SeccionFirmas";
import SeccionCorporateDatosOperacion from "./components/SeccionCorporateDatosOperacion";
import SeccionCorporateCuentas from "./components/SeccionCorporateCuentas";
import {SistemaTipo} from "../../../../types/enum/enum";

type SistemaCorporateContentProps = {
  operacion: OperacionCorporate,
}

const SistemaCorporateContent = ({ operacion }: SistemaCorporateContentProps) => {

  const { setSavePromise, permisoTipo, codSistemaTipo: codSistema } = useContext<ContextOperacionType>(ContextOperacion)

  const formMethods = useForm<FormOperacionCorporate>({
    resolver: zodResolver(schemaFormOperacionCorporate),
    values: { ...operacion }
  })

  const { showLoader, hideLoader } = useLoader()

  useEffect(() => {
    if (operacion.permiteEditarOperacion) {
      const handleSave: SubmitHandler<FormOperacionCorporate> = (data) => {
        showLoader()
        const promise = HttpCorporate.put(operacion[EntityWithIdFields.Id], data)

        toast.promise(promise, {
          loading: 'Guardando.',
          success: 'Guardado correctamente.',
          error: e => `${e}`
        }).finally(hideLoader)
      }

      const onSave = () => formMethods.handleSubmit(handleSave)
      setSavePromise(onSave)
    }
  }, [])


  return (
    <>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <SeccionCorporateDatosOperacion
            formMethods={formMethods}
            readOnly={!operacion.permiteEditarOperacion}
            operacion={operacion}
            codSistemaPrincipal={operacion.codPais}
            codSistema={codSistema}
          />
        </Grid>
        <Grid item xs={12}>
          <SeccionCorporateCuentas
            idOperacion={operacion[EntityWithIdFields.Id]}
            idPais={operacion.codPais}
            permiteEditar={permisoTipo > 1}
            permiteEliminar={operacion.permiteEliminarOperacion}
          />
        </Grid>
        <Grid item xs={12}>
          <SeccionFirmas
            codSistema={SistemaTipo.Corporate}
            idOperacion={operacion[EntityWithIdFields.Id]}
          />
        </Grid>
      </Grid>
    </>
  )
}


export const SistemaCorporate = () => {

  const { idOperacion } = useContext<ContextOperacionType>(ContextOperacion)

  const { status, operacion } = useOperacionCorporate(idOperacion)

  const { showLoader, hideLoader } = useLoader()

  useEffect(() => {
    if (status === QueryStatus.Loading) {
      showLoader()
    } else {
      hideLoader();
    }
  }, [status])

  if (!operacion) {
    return (
      <></>
    )
  }

  if (status === QueryStatus.Error) {
    return (
      <Alert severity='error'>
        Se produjo un error al cargar la operación.
      </Alert>
    )
  }

  return (
    <SistemaCorporateContent
      operacion={operacion}

      // setSavePromise={setSavePromise}
      // setCrearInforme={setCrearInforme}
    />
  )
}
